import React, { useEffect, useState } from 'react';
import { XIcon, CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Sarah M.',
  location: 'Austin, TX, USA'
}, {
  name: 'David L.',
  location: 'New York, NY, USA'
}, {
  name: 'Emily R.',
  location: 'Los Angeles, CA, USA'
}, {
  name: 'Michael C.',
  location: 'Chicago, IL, USA'
}, {
  name: 'Rachel K.',
  location: 'Miami, FL, USA'
}, {
  name: 'James T.',
  location: 'Denver, CO, USA'
}, {
  name: 'Megan B.',
  location: 'Seattle, WA, USA'
}, {
  name: 'Alex S.',
  location: 'Atlanta, GA, USA'
}, {
  name: 'Jessica P.',
  location: 'Portland, OR, USA'
}, {
  name: 'Brandon H.',
  location: 'Nashville, TN, USA'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const interval = setInterval(showPopup, 15000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-168">
          <div className="bg-white border-2 border-brand-gold shadow-[0_4px_22px_rgba(212,175,55,0.45)] rounded-lg p-2 pr-6 max-w-[280px] w-full relative overflow-hidden pointer-events-auto" data-id="element-169">
            <span className="absolute left-0 top-0 bottom-0 w-1.5 bg-brand-orange" data-id="element-170" />
            <button onClick={() => setVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close notification" data-id="element-171">
              <XIcon className="w-3.5 h-3.5" data-id="element-172" />
            </button>

            <div className="flex items-center gap-2.5 pl-1" data-id="element-173">
              <div className="w-8 h-8 rounded-full bg-brand-gold/15 flex items-center justify-center shrink-0 border border-brand-gold/40" data-id="element-174">
                <CheckCircle className="w-4 h-4 text-brand-gold" data-id="element-175" />
              </div>
              <div className="leading-tight" data-id="element-176">
                <p className="font-bold text-brand-green text-[13px]" data-id="element-177">
                  {currentPurchase.name}
                </p>
                <p className="text-[10px] text-brand-ink/60 font-medium" data-id="element-178">
                  from {currentPurchase.location}
                </p>
                <p className="text-[11px] text-brand-orange font-bold mt-0.5" data-id="element-179">
                  purchased the digital book
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}